import React from "react";
import "./assets/scss/normalize.scss";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "./layout/Layout";
import Homepage from "pages/Homepage";
import CountryPage from "pages/CountryPage";
import SingleArtistPage from "pages/SingleArtistPage";
import Galleries from "pages/GalleriesPage";
import SingleGalleryPage from "pages/SingleGalleryPage";
import PaintingsPage from "pages/PaintingsPage";
import ArtYerkirPage from "pages/ArtYerkirPage";
import GuidePage from "pages/GuidePage";
import PaintersPage from "pages/PaintersPage";
import SinglePaintingPage from "pages/SinglePaintingPage";
import RegistrationPage from "pages/RegistrationPage";
import MyProfileArtworksPage from "pages/myProfile/MyProfileArtworksPage";
import MyProfileAddArtworkPage from "pages/myProfile/MyProfileAddArtworkPage";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Homepage />} />
          <Route path="country/:countryName" exact element={<CountryPage />} />
          <Route path="artist/:id" exact element={<SingleArtistPage />} />
          <Route path="painting/:id" exact element={<SinglePaintingPage />} />
          <Route path="painters" exact element={<PaintersPage />} />
          <Route path="galleries" exact element={<Galleries />} />
          <Route path="galleries/:id" exact element={<SingleGalleryPage />} />
          <Route path="paintings" exact element={<PaintingsPage />} />
          <Route path="pan-armenian-arthub" exact element={<ArtYerkirPage />} />
          <Route path="guide" exact element={<GuidePage />} />
          <Route path="account/create" exact element={<RegistrationPage />} />
          <Route path="my-profile">
            <Route path="artworks" exact element={<MyProfileArtworksPage />} />
            <Route
              path="add-artwork"
              exact
              element={<MyProfileAddArtworkPage />}
            />
          </Route>
          <Route path="*" element={<Navigate to={"/"} />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
